import React from 'react';
import { Link } from 'react-router-dom';
import { XIcon } from 'lucide-react';
interface SearchItem {
  title: string;
  description: string;
  url: string;
  section?: string;
}
interface SearchResultsProps {
  results: SearchItem[];
  setShowSearchResults: (show: boolean) => void;
}
const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  setShowSearchResults
}) => {
  // Group results by section
  const groupedResults: Record<string, SearchItem[]> = {};
  results.forEach(result => {
    const section = result.section || 'Other';
    if (!groupedResults[section]) {
      groupedResults[section] = [];
    }
    groupedResults[section].push(result);
  });
  return <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-90">
      <div className="flex justify-between items-center mb-6" data-id="element-91">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-92">Search Results</h2>
        <button onClick={() => setShowSearchResults(false)} className="p-2 rounded-full hover:bg-gray-100" data-id="element-93">
          <XIcon className="h-5 w-5 text-gray-500" data-id="element-94" />
        </button>
      </div>
      {results.length === 0 ? <div className="text-center py-8" data-id="element-95">
          <p className="text-gray-600" data-id="element-96">
            No results found. Try a different search term.
          </p>
        </div> : <div data-id="element-97">
          <p className="text-gray-600 mb-4" data-id="element-98">Found {results.length} results</p>
          {Object.entries(groupedResults).map(([section, sectionResults]) => <div key={section} className="mb-8" data-id="element-99">
              <h3 className="text-lg font-semibold text-gray-800 mb-3" data-id="element-100">
                {section}
              </h3>
              <div className="grid gap-4" data-id="element-101">
                {sectionResults.map((result, index) => <Link key={index} to={result.url} onClick={() => setShowSearchResults(false)} className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50" data-id="element-102">
                    <h4 className="text-blue-600 font-medium" data-id="element-103">
                      {result.title}
                    </h4>
                    <p className="text-gray-600 text-sm mt-1" data-id="element-104">
                      {result.description}
                    </p>
                  </Link>)}
              </div>
            </div>)}
        </div>}
    </div>;
};
export default SearchResults;